// extracted by mini-css-extract-plugin
module.exports = {"expertiseList":"ExpertiseList_expertiseList__3gscx","expertiseText":"ExpertiseList_expertiseText__CcnRs","modal":"ExpertiseList_modal___6jbj"};